module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMjAwIiBoZWlnaHQ9IjgwMCIgdmlld0JveD0iMCAwIDM2IDI0Ij48cGF0aCBmaWxsPSIjNzVhYWRiIiBkPSJNMCAwaDM2djI0SDB6Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTAgOWgzNnY2SDB6Ii8+PHBhdGggZD0iTTAgMTBoMzZ2NEgweiIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/bwa.svg
// module id = IoEN
// module chunks = 0